import { fn } from "n24-ui";
import { AppStore } from "./app.store";
import { UIStore } from "./ui.store";
import { UserStore } from "./user.store";
import { CategoryStore } from "./category.store";
import { NewsLetterStore } from "./newsletter.store";

export class RootStore {
  ui: UIStore;
  app: AppStore;
  user: UserStore;
  category: CategoryStore;
  newsLetter: NewsLetterStore;

  constructor() {
    this.ui = new UIStore(this);
    this.app = new AppStore();
    this.user = new UserStore(this);
    this.category = new CategoryStore(this);
    this.newsLetter = new NewsLetterStore(this);
  }
}

export const [useStore, StoreContextProvider] = fn.createCtx<RootStore>();
